/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.Timer";
        class TimerWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("TimerWidgetTypeClass.createInstance()");
                    return new TimerWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("TimerWidgetTypeClass._storeHtml()");
                    TimerWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("TimerWidgetTypeClass::constructor");
                if (TimerWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/Timer/timer.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.TimerWidgetTypeClass = TimerWidgetTypeClass;
        class TimerWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._timers = [];
                this.presentInstance = () => {
                    this._log.info("TimerWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = TimerWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._widgets.setTitle(this._config, this._container.querySelector('#timerWidgetHeading'), 'STR_WPT_TIMER');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    let config = this._config;
                    if (config.hasOwnProperty('Timers') && config.Timers && (config.Timers.length > 0))
                        this._timers = config.Timers;
                    else
                        this._timers = [];
                    let indexer = 1;
                    this._timers.forEach(timer => {
                        if (!timer.hasOwnProperty('Identifier') || (timer.Identifier == null))
                            timer.Identifier = indexer.toString();
                        if (!timer.hasOwnProperty('Label') || (timer.Label == null))
                            timer.Label = timer.Identifier;
                        if (!timer.hasOwnProperty('Interval') || (timer.Interval == null))
                            timer.Interval = 60;
                        if (!timer.hasOwnProperty('Code') || (timer.Code == null))
                            timer.Code = indexer;
                        if (!timer.hasOwnProperty('Active') || (timer.Active == null))
                            timer.Active = true;
                        indexer++;
                    });
                    this._startTimers();
                    this._type.instanceReady(this.getHandle());
                };
                this._callFailedHandler = (json) => {
                    this._log.info("TimerWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("TimerWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                };
                this._startTimers = () => {
                    this._log.info("TimerWidgetInstanceClass._startTimers()");
                    // Use indexer to avoid getting into this/bind issues
                    for (let i = 0; i < this._timers.length; i++) {
                        let timer = this._timers[i];
                        if (timer.Active) {
                            // Don't user setInterval because it's unclear when the interval will stop firing
                            window.setTimeout(this._processTick.bind(this, timer.Identifier), timer.Interval * 1000);
                        }
                    }
                };
                this._processTick = (timerId) => {
                    this._log.info("TimerWidgetInstanceClass._processTick()");
                    let timer = this._timers.find(t => t.Identifier == timerId);
                    if (timer) {
                        // Apparently timers can survive logout - need to ensure they don't
                        // Also need to prevent home screen timers pulling people out of DVs
                        if (this._core.isUserLoggedIn()) {
                            if (timer.Active) {
                                if (this._core.Navigation.Details.getActiveLayoutName() == this._currentLayout) {
                                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.TIMER_TICK);
                                    navEvent.ActivationID = timer.Code;
                                    navEvent.PrimaryContext = timer.Identifier;
                                    navEvent.Layout = this._currentLayout;
                                    this._core.Navigation.Details.requestActivation(navEvent);
                                }
                                window.setTimeout(this._processTick.bind(this, timer.Identifier), timer.Interval * 1000);
                            }
                        }
                        else {
                            this.setTimerState(timerId, false);
                        }
                    }
                    else {
                        console.warn(`TimerWidgetInstanceClass - attempt to trigger unknown timer '${timerId}'`);
                    }
                };
                this.setTimerState = (timerId, active) => {
                    this._log.info("TimerWidgetInstanceClass.setTimerState()");
                    let timer = this._timers.find(t => t.Identifier == timerId);
                    if (timer) {
                        if (timer.Active)
                            timer.Active = active;
                        else {
                            if (active) {
                                timer.Active = active;
                                window.setTimeout(this._processTick.bind(this, timer.Identifier), timer.Interval * 1000);
                            }
                        }
                    }
                    else
                        return false;
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("TimerWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
            }
        }
        TimerWidgetInstanceClass.HtmlData = null;
        Widgets.TimerWidgetInstanceClass = TimerWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
